import { HSLColor } from "react-color";

const transparent: HSLColor = {
    h: 0,
    s: 0,
    l: 0,
    a: 0,
};

const black: HSLColor = {
    h: 0,
    s: 0,
    l: 0,
    a: 1,
};

const silver: HSLColor = {
    h: 0,
    s: 0,
    l: 27,
    a: 1,
};

export const HSLColors = {
    black,
    silver,
    transparent,
};
